/* eslint-disable max-len */
const LogoMobile: JSX.Element = (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 26.0066C0 31.1502 1.53118 36.1783 4.39994 40.4551C7.2687 44.7319 11.3462 48.0652 16.1168 50.0336C20.8873 52.002 26.1368 52.517 31.2012 51.5135C36.2656 50.51 40.9176 48.0331 44.5688 44.396C48.22 40.759 50.7065 36.125 51.7139 31.0802C52.7213 26.0355 52.2043 20.8064 50.2283 16.0543C48.2522 11.3022 44.9059 7.24055 40.6125 4.38291C36.3191 1.52527 31.2714 0 26.1078 0C19.1857 0.0069896 12.5492 2.74921 7.65455 7.62488C2.75991 12.5006 0.0070168 19.1114 0 26.0066Z"
      fill="white"
    />
    <path
      d="M51.0361 26.0064C51.0361 30.9177 49.5741 35.7186 46.8349 39.8022C44.0957 43.8857 40.2024 47.0685 35.6474 48.9479C31.0923 50.8274 26.0801 51.3191 21.2445 50.361C16.4089 49.4028 11.9671 47.0379 8.48079 43.5651C4.9945 40.0923 2.62032 35.6677 1.65845 30.8509C0.696589 26.034 1.19022 21.0412 3.07699 16.5038C4.96375 11.9664 8.1589 8.08818 12.2583 5.35964C16.3578 2.6311 21.1774 1.17474 26.1077 1.17474C32.7191 1.17474 39.0598 3.79093 43.7347 8.44778C48.4097 13.1046 51.0361 19.4207 51.0361 26.0064Z"
      fill="#E50B00"
    />
    <path
      d="M26.0415 1.17474C20.8032 1.18209 15.7003 2.83209 11.4564 5.89073C7.21246 8.94936 4.04299 13.2614 2.39752 18.2152C0.752055 23.169 0.714109 28.5131 2.28905 33.4896C3.864 38.466 6.97188 42.8223 11.1719 45.9404L26.0415 1.17474Z"
      fill="#004C5F"
    />
    <path
      d="M20.6874 17.3464H3.06128L17.2947 27.6038L20.6874 17.3464Z"
      fill="white"
    />
    <path
      d="M26.1077 1.17474L20.7139 17.3464H32.1642L26.1077 1.17474Z"
      fill="white"
    />
    <path
      d="M17.2815 27.6038L11.3708 45.4916L26.1078 34.5345L42.1303 45.2276L36.0341 27.5774L49.4326 17.3464L17.2815 27.6038Z"
      fill="white"
    />
    <path
      d="M77.6606 34.4952L84.128 17.3071H87.8917L94.2265 34.4952H90.3567L86.0231 21.6767L81.7425 34.4952H77.6606Z"
      fill="white"
    />
    <path
      d="M82.2461 34.4949L86.0231 31.485L89.7206 34.4949H82.2461Z"
      fill="white"
    />
    <path
      d="M96.2146 17.3071H100.018V31.3533H105.995V34.4952H96.2146V17.3071Z"
      fill="white"
    />
    <path
      d="M104.537 17.3071H116.743V20.4094H112.462V34.5348H108.592V20.4094H104.537V17.3071Z"
      fill="white"
    />
    <path
      d="M119.181 17.3464H128.776V20.4091H122.932V24.1979H128.445V27.3002H122.932V31.3134H130.433L127.862 34.5345H119.181V17.3464Z"
      fill="white"
    />
    <path
      d="M131.825 17.3464H136.808L139.564 22.1649L142.268 17.3464H147.224L141.83 25.1484L149 34.5345H144.189L139.71 28.4223L135.111 34.5345H130.261L137.311 25.188L131.825 17.3464Z"
      fill="white"
    />
    <path
      d="M76.5077 21.901V18.1518C72.3198 16.1981 67.9332 17.571 65.2297 21.703C64.29 23.1913 63.8573 24.9418 63.9958 26.6946C64.1342 28.4473 64.8365 30.1088 65.9983 31.4324C68.0922 34.0067 71.5644 35.3136 76.5077 34.0727V30.1123C73.38 31.7624 69.7356 31.0363 68.2778 28.4885C66.6609 24.6073 68.9139 21.0033 72.0548 20.7129C73.6322 20.5103 75.2272 20.9217 76.5077 21.8614"
      fill="white"
    />
  </svg>
);

export default LogoMobile;
